export default __webpack_public_path__ + "static/media/ded-tools-trello.f3b6f420.svg";